module.exports = __webpack_public_path__ + "static/media/messagesIcon.2ef5d8e2.svg";